/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const styles = {
  topInstructorBadge: css`
    display: inline-block;
    background-color: #d3ddf4;
    padding: 1px 5px;
    border-radius: 4px;
  `,
  topInstructorBadgeText: css`
    font-weight: 600;
    white-space: nowrap;
  `,
};

const TopInstructorBadge = () => {
  return (
    <div css={styles.topInstructorBadge}>
      <Typography2 variant="subtitleMedium" component="p" color="highlightBlue" css={styles.topInstructorBadgeText}>
        {_t('Top Instructor')}
      </Typography2>
    </div>
  );
};

export default TopInstructorBadge;
